import { CurrencySettings, LogManager, Model, ModelRow } from "@mcleod/core";
import { AutogenLayoutMiscInvoiceHistoryList } from "./autogen/AutogenLayoutMiscInvoiceHistoryList";
import { Panel, TableRowExpansionEvent } from "@mcleod/components";
import { AutogenLayoutMiscInvoiceHistoryExpand } from "./autogen/AutogenLayoutMiscInvoiceHistoryExpand";

const log = LogManager.getLogger("lme.ar.MiscInvoiceHistoryList");

export class MiscInvoiceHistoryList extends AutogenLayoutMiscInvoiceHistoryList {
    private isMultiCurrencyEnabled: boolean;
    private segAllocControl: ModelRow;

    override async onLoad() {
        this.isMultiCurrencyEnabled = CurrencySettings.getSingleton()?.multiCurrencyEnabled();
        this.textboxCurrencySearch.visible = this.isMultiCurrencyEnabled;

        try {
            this.segAllocControl = await Model.searchSingleRecord("lme/settlement/seg-alloc-control", null, { extraFields: "lme/dispatch/seg-alloc-control-single" });
        } catch (error) {
            log.error("Failed to load segment allocation control settings:", error);
            this.segAllocControl = null;
        }

        // Listen for when a row is expanded - that's when the GL table gets created
        this.tableMiscInvoicingHistory.addRowExpandListener((event: TableRowExpansionEvent) => {
            this.onRowExpand(event);
        });
    }

    onRowExpand(event: TableRowExpansionEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data as ModelRow;
        const expandPanel = event.expandComponentParent as Panel;
        const layoutMiscInvoiceHistoryExpand = expandPanel.findComponentById("layoutMiscInvoiceHistoryExpand") as AutogenLayoutMiscInvoiceHistoryExpand;
        const miscInvoiceId = modelRow.getString("id", null);

        if (miscInvoiceId && layoutMiscInvoiceHistoryExpand) {
            layoutMiscInvoiceHistoryExpand.sourceMiscBillHist.search({ "id": miscInvoiceId })
                .catch(error => {
                    log.error(`Failed to load expanded row data for invoice history invoice ${miscInvoiceId}:`, error);
                });

            layoutMiscInvoiceHistoryExpand.textboxAllocationCode.visible = !!this.segAllocControl && this.segAllocControl.getBoolean("is_active", false);

            // Trigger search for sourceJournalSales to ensure data is loaded
            const postKey = modelRow.getString("post_key", null);
            const postModule = modelRow.getString("post_module", null);
            layoutMiscInvoiceHistoryExpand.sourceJournalSales.search({ "post_key": postKey, "post_module": postModule })
                .catch(error => {
                    log.error(`Failed to load journal sales data for invoice history invoice ${miscInvoiceId}:`, error);
                });
        }
    }
}
